module.exports = __webpack_public_path__ + "media/customizations/vanmetre/logo-29ae826ef2da7d11001f5266f3b36757.png";